<form [formGroup]="userInfoForm" #userCreator>
    <h4 class="form-title">{{'PROFILE.ID_AUTHOR'|translate}}</h4>
    <mat-card class="form-section mat-elevation-z0">
  
      <mat-card-content fxLayout="column">
        <mat-form-field appearance="outline" class="input-form-field">
          <mat-label>{{'PROFILE.EDIT.EMAIL'|translate}}</mat-label>
          <input matInput formControlName="email" placeholder="email" maxlength="120">
          <mat-hint *ngIf="false">Hint</mat-hint>
        </mat-form-field>
      </mat-card-content>
      <mat-card-content fxLayout="column">
  
        <mat-form-field appearance="outline" class="input-form-field">
          <mat-label>{{'PROFILE.EDIT.NAME'|translate}}</mat-label>
          <input matInput formControlName="name" placeholder="Nombre" required maxlength="120">
          <mat-hint *ngIf="false">Hint</mat-hint>
        </mat-form-field>
      </mat-card-content>
    </mat-card>
    <div fxLayoutGap="row" [style.margin-top.rem]="1">
      <div fxFlex></div>
      <div fxFlexAlign="end">
        <button mat-flat-button color="primary" [mat-dialog-close]="userInfoForm.value"
      cdkFocusInitial>{{'PROFILE.ACCEPT'|translate}}</button>
    <button mat-flat-button *ngIf="data.messageType === 'question' || data.messageType === 'warning'" color="accent"
      [mat-dialog-close]="false" (click)="closeMe()">{{'PROFILE.CANCEL'|translate}}</button>
    <button mat-flat-button *ngIf="data.messageType !== 'question' && data.messageType !== 'warning'" color="primary"
      [mat-dialog-close]="true" (click)="closeMe()">{{'PROFILE.CLOSE'|translate}}</button>
      </div>
    </div>
  </form>
